export const getDateFormat = locale => {
  switch (locale) {
    case 'es_MX':
    case 'es_US':
      return 'D [de] MMMM [de] YYYY';
    case 'fr_CA':
      return 'D MMMM YYYY';
    default:
      return 'MMMM Do[,] YYYY';
  }
};

export const getLocale = languageCode => {
  switch (languageCode) {
    case 'fr':
      return require('date-fns/locale/fr');
    case 'es':
      return require('date-fns/locale/es');
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/constants/date.js